import * as z from 'zod/mini';
const datetimeRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
export const DateISO = z.string().check(z.refine((v) => {
    const match = v.match(datetimeRegex);
    if (!match) {
        return false;
    }
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return !Number.isNaN(date.getTime());
}, 'Invalid date format'));
//# sourceMappingURL=DateISO.js.map